/* eslint-disable prefer-promise-reject-errors */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form, Input } from 'antd-v5';
import { SettingsContent } from '../../../components/SettingsContent';
import EditProfilePic from '../../../../../../components/Layout/ProfilePic/EditProfilePic';
import 'react-phone-number-input/style.css';
import PhoneInput from '../../../../../CustomizedAntDesign/PhoneInput';
import { UploadAvatar } from '../../../../../CustomizedAntDesign/UploadAvatar';

export const ProfileDetails = ({ form, imageInfo, initials, isoCountryCode }) => {
  const normFile = e => {
    if (e.fileList.length > 0) {
      return e.fileList[0];
    }
    return null;
  };

  return (
    <SettingsContent
      icon={<FontAwesomeIcon icon={['far', 'user']} />}
      title="Profile Information"
      description="Manage your personal information"
    >
      <div className="flex-col-left w-100-P">
        <Form.Item name="image" getValueFromEvent={normFile}>
          <UploadAvatar initials={initials} defaultValue={imageInfo.profilePic} />
        </Form.Item>
        {/* <EditProfilePic image={imageInfo} initials={initials} /> */}

        <div className="flex-col-left w-100-P">
          <div className="flex-row-nospacebetween-wrap" style={{ gap: '16px', width: '100%' }}>
            <Form.Item
              name="firstName"
              label="First Name"
              rules={[
                { required: true, message: 'Please enter your first name' },
                { min: 1, message: 'First name cannot be empty' },
              ]}
              style={{ flex: 1, minWidth: '200px' }}
            >
              <Input placeholder="First Name" />
            </Form.Item>

            <Form.Item
              name="lastName"
              label="Last Name"
              rules={[{ required: true, message: 'Please enter your last name' }]}
              style={{ flex: 1, minWidth: '200px' }}
            >
              <Input placeholder="Last Name" />
            </Form.Item>
          </div>
          <div className="flex-row-nospacebetween-wrap" style={{ gap: '16px', width: '100%' }}>
            <Form.Item
              name="mobile"
              label="Mobile Phone"
              rules={[
                () => ({
                  validator(rule, value) {
                    if (!value) {
                      return Promise.resolve();
                    }
                    if (value && ((!value?.phoneNumber && !value?.areaCode) || value?.valid())) {
                      return Promise.resolve();
                    }
                    return Promise.reject('The inserted phone number  is not valid !');
                  },
                }),
              ]}
              style={{ flex: 1, minWidth: '200px' }}
            >
              <PhoneInput
                placeholder="Enter phone number"
                defaultCountry={isoCountryCode}
                countryOptionsOrder={[isoCountryCode, '|']}
              />
            </Form.Item>

            <Form.Item
              name="email"
              label="Email"
              rules={[
                { required: true, message: 'Please enter your email' },
                { type: 'email', message: 'Please enter a valid email address' },
              ]}
              style={{ flex: 1, minWidth: '200px' }}
            >
              <Input placeholder="Email" type="email" />
            </Form.Item>
          </div>
        </div>
      </div>
    </SettingsContent>
  );
};
